import React, { useContext, useEffect, useState } from "react";
import { CSVLink } from "react-csv";

import classes from "../../../pages/AdminPortal.module.css";
import tableClasses from "./Tables.module.css";
import EventContext from "../../../store/EventContext";

const EventDetails = ({ event }) => {
  const { getRegistrants, registrants } = useContext(EventContext);
  const [selectedRegistrant, setSelectedRegistrant] = useState(null);

  useEffect(() => {
    getRegistrants(event.id);
  }, [event.id, getRegistrants]);

  const formatPhoneNumber = (number) => {
    let numberArr = number.split("");
    numberArr.splice(numberArr.length - 4, 0, "-");
    numberArr.splice(numberArr.length - 8, 0, "-");
    return numberArr.reduce((acc, char) => acc + char, "");
  };

  const formatRegistrantsToCSV = (regs) => {
    //*Create the column headers
    const headers = [];
    const firstEntry = regs[0];
    if (firstEntry) {
      Object.entries(firstEntry).map(([key, value]) => headers.push(key));
    }
    //*Insert the child headers of custom_input_obj object headers into the main header
    // Determine the headers of custom_input_obj
    const customInputsHeaders = [];

    if (firstEntry) {
      Object.entries(firstEntry.custom_inputs_obj).map(([key, value]) => {
        if (!key.includes("Team")) {
          customInputsHeaders.push(key);
        }
      });
      //Insert them into the headers array
      let targetIndex;
      headers.forEach((header, index) => {
        if (header === "custom_inputs_obj") {
          targetIndex = index;
        }
      });
      headers.splice(targetIndex, 1, ...customInputsHeaders);
    }

    //*Add in the remaining data
    const allValuesArr = [];
    if (regs) {
      regs.forEach((reg) => {
        const values = [];
        Object.entries(reg).map(([key, value], index) => {
          values.push(value);
          if (typeof value === "object") {
            let objectString = "";
            Object.entries(value).forEach(
              ([key, value]) => {
                if (typeof value === "object") {
                  objectString += `•${key} \n`
                  value.forEach(val => objectString += `----${val} \n`)
                } else {
                  (objectString += `${key}: \n ----${value} \n`)
                }
                objectString += "\n"
              }
            );

            values.splice(index, 1, objectString);
          }
        });

        allValuesArr.push(values);
      });
    }
    // console.log(allValuesArr);
    const csvData = [headers, ...allValuesArr];
    // console.log(csvData)
    return csvData;
  };
  // console.log(registrants);
  // console.log(formatRegistrantsToCSV(registrants));
  formatRegistrantsToCSV(registrants);

  return (
    <div className={classes.page}>
      <h2>{`${event.event_title} ${new Date(
        event.event_date
      ).getFullYear()}`}</h2>
      <h2>{event.event_location}</h2>
      <br />
      <br />
      <table className={tableClasses.table}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Company</th>
          </tr>
        </thead>
        <tbody>
          {registrants.map((reg) => (
            <React.Fragment key={reg.id}>
              <tr
                className={
                  selectedRegistrant === reg.id ? tableClasses.selectedRow : ""
                }
                onClick={() =>
                  setSelectedRegistrant((prev) =>
                    prev === reg.id ? null : reg.id
                  )
                }
              >
                <td>{`${reg.first_name} ${reg.last_name}`}</td>
                <td>{reg.company}</td>
              </tr>
              {selectedRegistrant === reg.id && (
                <React.Fragment>
                  <tr key={reg.id} className={tableClasses.expansionRow}>
                    <td>Email: {reg.email}</td>
                    <td>Phone: {formatPhoneNumber(reg.phone)}</td>
                  </tr>
                  <tr className={tableClasses.expansionRow}>
                    <td>{reg.address}</td>
                    <td>{new Date(reg.created_at).toLocaleDateString()}</td>
                  </tr>
                  {Object.entries(reg.custom_inputs_obj).map(([key, value]) => (
                    <tr
                      key={`${key}${value}`}
                      className={tableClasses.expansionRowCustomInputs}
                    >
                      <td style={{ textAlign: "right" }}>{key}--</td>
                      <td>{value}</td>
                    </tr>
                  ))}
                </React.Fragment>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      <CSVLink data={formatRegistrantsToCSV(registrants)}>
        Download CSV file
      </CSVLink>
    </div>
  );
};

export default EventDetails;

//* THIS IS AN EXAMPLE OF HOW TO FORMAT CSV DATA SO THAT IT
//* PRODUCES A HEADER AND THE FOLLOWING ARRAY WILL HAVE
//* RETURN CARRIAGE AFTER EACH ADULT
// const formatCSV = () => {
//   let adults = "";
//   adultAttendees.forEach((obj) => {
//     let currentAdult = "";
//     Object.entries(obj).map(([key, index]) => {
//       if (key === "name") {
//         currentAdult += `${index} - `;
//       } else if (key === "email") {
//         currentAdult += index;
//       }
//     });
//     adults += `${currentAdult} \n`;
//   });
//   console.log(adults);
//   return [["Adults Attending"],[adults]]
// };
